import { SignUp } from "@clerk/react";

export default function SignUpPage() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex relative items-end p-12 border-r border-[#262626]">
        <img
          src="https://images.pexels.com/photos/6720527/pexels-photo-6720527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Driver in truck"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="relative z-10 max-w-md">
          <div className="font-mono-label text-xs text-[#FFD600] mb-3">GET STARTED</div>
          <h2 className="font-heading font-black text-4xl leading-none mb-3">Your authority, 48 hours away.</h2>
          <p className="text-muted-foreground">Create an account and we'll walk you through every FMCSA filing.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6" data-testid="sign-up-container">
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
      </div>
    </div>
  );
}
